<template>
  <div class="fill-after-sale-info">
    <navbar title="服务单详情" show-home left-text> </navbar>
    <div class="info-wrapper">
      <div class="progress-details" v-if="serviceDetails.timeline">
        <div class="title">进度详情</div>
        <ul>
          <li v-for="(step, index) in timeline" :key="index">
            <div class="progress-step">
              <div class="step-line"></div>
              <div class="step-icon step-icon-finish"></div>
            </div>
            <div class="progress-intro">
              <p>{{step.msg}}</p>
              <p>{{step.time}}</p>
            </div>
          </li>
          <li>
            <div class="progress-step">
              <div class="step-line"></div>
              <div class="step-icon" :class="serviceDetails.status >= 90001 ? 'step-icon-finish' : ''"></div>
            </div>
          </li>
        </ul>
      </div>
      <div class="product-details" v-if="serviceDetails">
        <div class="product-img">
          <img v-lazy="serviceDetails.sku_img">
        </div>
        <div class="product-intro">
          <div class="title">{{serviceDetails.sku_name}}</div>
          <div class="gift-name">
            <span>{{serviceDetails.sku_name}}</span>
          </div>
          <div class="product-num">申请数量: {{serviceDetails.sku_num}}</div>
        </div>
      </div>
      <!-- <div class="product-num-handle" >
        <div>申请售后数量: </div>
        <div>{{serviceDetails.sku_num}}</div>
      </div> -->
      <div class="after-why">
        <em>申请售后原因</em>
        <em>{{serviceDetails.reason}}</em>
      </div>
      <div class="contact-records">
        <h2>问题沟通记录</h2>
        <div class="problem-desc">
         <div class="problem-desc-tit">
            <h3>问题描述</h3>
            <p>{{serviceDetails.create_at}}</p>
         </div>
          <textarea disabled :value="serviceDetails.reason_desc"></textarea>
          <div class="upload-img" v-if="serviceDetails.pic_list && serviceDetails.pic_list.length">
            <img v-for="(item, index) in serviceDetails.pic_list" :key="index" v-lazy="item.url" >
          </div>
        </div>
        <div class="service-reply" v-if="serviceDetails.reply_detail ">
          <div class="service-reply-tit">
            <h3>客服审核答复</h3>
            <p>{{serviceDetails.update_at}}</p>
          </div>
          <textarea disabled :value="serviceDetails.reply_detail"></textarea>
        </div>
      </div>
      <div class="service-ticket" v-if="serviceDetails">
        <p>服务单号：{{serviceDetails.serial_no}} </p>
        <p>申请时间：{{serviceDetails.create_at}}</p>
        <!-- <p>服务类型：<em>换货</em></p> -->
      </div>
    </div>
    <div class="send-back-info" v-if="serviceDetails.refund">
      <p>商品退回: <em>等待安排快递取回</em></p>
      <template >
        <p>用户收货地址：{{userAdderss(serviceDetails.refund.receiver_addr)}}</p>
        <p>联系人: {{serviceDetails.refund.name}}</p>
        <p>联系电话：{{serviceDetails.refund.mobile}}</p>
      </template>
    </div>
    <div class="send-back-info" v-if="serviceDetails.return_addr">
      <!-- <p>商品退回: <em>等待安排快递取回</em></p> -->
      <template>
        <p>商品寄回地址: {{serviceDetails.return_addr.full_address}}</p>
        <p>联系人: {{serviceDetails.return_addr.name}}</p>
        <p>联系电话：{{serviceDetails.return_addr.mobile}}</p>
      </template>
    </div>
    <div class="contact-service">
      <h3>联系客服</h3>
      <p>有问题请您拨打客服电话：400-6687017</p>
      <p>（服务时间：工作日 09:30 -18:00）</p>
      <div class="online-service">
        <online-service />
      </div>
    </div>

  </div>
</template>

<script>
import Navbar from '../components/NavBar'
import OnlineService from '../components/OnlineService'
export default {
  name: 'ServiceSheetDetails',
  components: {
    Navbar,
    OnlineService
  },
  data () {
    return {
      serviceDetails: {},
      steps: []
    }
  },
  computed: {
    userAdderss (address) {
      return (address) => {
        return address.province_name + address.city_name + address.district_name + address.town_name + address.address_detail
      }
    }
  },
  created () {
    this.getServiceDetails()
  },
  methods: {
    async getServiceDetails () {
      this.$toast.loading('加载中...')
      const res = await this.$axios.get(`api/refund/detail/${this.$route.query.refId}`)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          this.serviceDetails = data
          this.timeline = data.timeline
        } else {
          this.$toast(msg)
        }
      }
    }
  }

}
</script>

<style lang="less" scoped>
.fill-after-sale-info {
  .info-wrapper {
    h3 {
      font-size: 0.28rem;
      font-weight: 550;
    }
  }
}
.progress-details {
  padding: 0.27rem 0.34rem;
  background-color: #FFF9E6;
  .title {
    font-size: 0.28rem;
    color: #404040;
    font-weight: 550;
    margin-bottom: 0.22rem;
  }
  ul {
    li {
      position: relative;
      height: 1rem;
      display: flex;
      font-size: 0.24rem;
      color: #404040;
      .progress-step {
        width: 0.2rem;
        margin-right: 0.3rem;
        .step-line {
          position: absolute;
          width: 0.02rem;
          top: 0;
          left: 0.03rem;
          bottom: 0;
          background-color: #F5A623;
        }
        .step-icon, .step-icon-finish {
          position: relative;
          width: 0.1rem;
          height: 0.1rem;
          border: 0.5px solid #F5A623;
          background-color: #fff;
          box-sizing: border-box;
          border-radius: 50%;
          z-index: 3;
        }
        .step-icon-finish {
          background-color:#FFD897;
        }
      }
      .progress-intro {
        margin-top: -0.05rem;
      }
    }
    li:last-child {
      .progress-step {
        .step-line {
          display: none;
        }
      }
    }
  }
}
.product-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 0.24rem 0.45rem 0.28rem;
  border-bottom: 0.5px solid #eaeaea;
  .product-img {
    width: 2rem;
    height: 2rem;
    padding: 0.12rem;
    border: 0.5px solid #f2f2f2;
    box-sizing: border-box;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .product-intro {
    width: 4.4rem;
    height: 100%;
    font-size: 0.24rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      color: #333;
      font-weight: 550;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* 超出两行*/
      -webkit-box-orient: vertical;
      overflow: hidden;
      padding-top: 0.05rem;
    }
    .gift-name {
      font-size: 0.2rem;
      color: #9b9b9b;
      padding: 0.15rem 0 0.35rem;
      display: flex;
      span {
        // width: 100%;
        padding: 0.02rem 0.08rem;
        color: #9b9b9b;
        border: 1px solid #eaeaea;
        border-radius: 0.04rem;
        background-color: #f8f8f8;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .product-price {
      display: flex;
      justify-content: space-between;
      color: #404040;
      .price {
        em {
          color: #ff2851;
        }
      }
    }
    .product-num {
      font-size: 0.24rem;
      color: #404040;
      padding-bottom: 0.14rem;
    }
  }
}
.product-num-handle {
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.45rem;
  font-size: 0.28rem;
  color: #404040;
  font-weight: 550;
  background-color: #fff;
  margin-bottom: 0.2rem;
  div:nth-child(2) {
    color: #ccc;
    font-weight: normal;
  }
}
.after-why {
  height: 0.88rem;
  background-color: #fff;
  font-size: 0.24rem;
  color: #404040;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.45rem;
  margin: 0.2rem 0;
}
.contact-records {
  background-color: #fff;

  h2 {
    font-size: 0.28rem;
    color: @base;
    height: 0.9rem;
    padding-left: 0.51rem;
    border-bottom: 0.5px solid #EAEAEA;
    box-sizing: border-box;
    font-weight: 600;
    display: flex;
    align-items: center;
  }
  .problem-desc {
    padding: 0.3rem 0.45rem 0.15rem;
    .problem-desc-tit {
      display: flex;
      justify-content: space-between;
      font-size: 0.28rem;
      p {
        color: #ccc;
      }
      h3 {
        font-weight: 500;
      }
    }
    textarea {
      width: 6rem;
      height: 1.56rem;
      padding: 0.3rem;
      border: 0.5px solid #808080;
      margin: 0.24rem 0;
      font-size: @fz28;
      color: @base;
      background-color: #fafafa;
      vertical-align: top;
    }
    .upload-img {
      display: flex;
      padding-bottom: 0.2rem;
      border-bottom: 0.5px solid #EAEAEA;
      img {
        width: 1rem;
        height: 1rem;
        border: 0.5px solid #9e9e9e;
        box-sizing: border-box;
        margin-right: 0.4rem;
        object-fit: contain;
      }
      img:last-child {
        margin-right: 0;
      }
    }
  }
  .service-reply {
      padding:  0 0.45rem;
     .service-reply-tit {
      display: flex;
      justify-content: space-between;
      font-size: 0.28rem;
      p {
        color: #ccc;
      }
      h3 {
        font-weight: 500;
        color: #FF9600;
      }
    }
    textarea {
      width: 6rem;
      height: 1.56rem;
      padding: 0.3rem;
      font-size: @fz28;
      color: @base;
      border: 0.5px solid #808080;
      margin: 0.24rem 0;
      background-color: #fafafa;
      vertical-align: top;
    }
  }
}
.service-ticket {
  font-size: 0.28rem;
  color: #404040;
  background-color: #fff;
  padding: 0.3rem 0.45rem;
  margin: 0.2rem 0;
  line-height: 1.5;
  word-break: break-all;
  em {
    color: #FF3B3B;
    font-weight: 550;
  }
}
.send-back-info {
  font-size: 0.28rem;
  color: #404040;
  background-color: #fff;
  padding: 0.3rem 0.45rem;
  margin-bottom: 0.22rem;
  line-height: 1.5;
}
.contact-service {
  padding: 0.16rem 0.45rem;
  background-color: #fff;
  color: #404040;
  margin-bottom: 0.78rem;
  h3 {
    position: relative;
    font-size: 0.28rem;
    font-weight: 550;
    padding-bottom: 0.2rem;
  }
  h3::after {
    position: absolute;
    content: '';
    width: 0.06rem;
    height: 0.25rem;
    top: 50%;
    transform: translateY(-50%);
    left: -0.25rem;
    background-color: #FF9600;
  }
  p {
    font-size: 0.24rem;
    line-height: 1.6;
  }
}
.online-service {
  padding-top: 0.3rem;
}
</style>
